<template>
    <v-flex xs12 class="chapter" v-if="showComponents">
        <v-layout
            row
            wrap
            justify-space-between>
            <v-layout row wrap>
                <v-flex xs12 class="chapter__middle ">
                    <confidentiality-reminder-dialog v-if="this.$route.path.includes('/forum')"></confidentiality-reminder-dialog>
                    <feature-event v-if="showFeatureEvents"></feature-event>
                    <admin-page v-if="showInappropriate"></admin-page>
                    <return-to-activity-feed v-if="showBackToActivityFeedButton"></return-to-activity-feed>
                    <add-post v-else></add-post>
                    <chapter-welcome-message v-if="chapterRoute || networkRoute"/>
                    <activity-feed v-if="!isMainActivityFeedHidden" :show-inappropriate-posts="false" :can-view-activity-feed="canViewActivityFeed"></activity-feed>
                </v-flex>
            </v-layout>
        </v-layout>
        <non-member-message v-if="isVisible"></non-member-message>
    </v-flex>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { storeGetters } from '../../store/storeGetters.constant';
    import SponsorCard from './SponsorCard/SponsorCard';
    import ActivityFeed from './ActivityFeed/ActivityFeed';
    import FeatureEvent from "./FeatureEvent/FeatureEvent";
    import AdminPage from "./AdminPage/AdminPage";
    import NonMemberMessage from './NonMemberMessage/NonMemberMessage';
    import AddPost from "./AddPost/AddPost";
    import { communityCommonConstant } from './communityCommon.constant';
    import ReturnToActivityFeed from "./ActivityFeed/ReturnToActivityFeed";
    import { routerNames } from '../appCommon.constants';
    import ConfidentialityReminderDialog from '../ForumPage/ConfidentialityReminderDialog';
    import { gaDataLayerEvent } from '../../plugins/analytics';
    import { gtmEventName } from "@/plugins/gtmAnalytics";
    import ChapterWelcomeMessage from './ChapterWelcomeMessage.vue';
    import { trackPageLoadTime } from '../../common/utils/performance';

    export default {
        name: 'ChapterPage',

        components: {
            ReturnToActivityFeed,
            AddPost,
            FeatureEvent,
            ActivityFeed,
            SponsorCard,
            AdminPage,
            NonMemberMessage,
            ConfidentialityReminderDialog,
            ChapterWelcomeMessage,
        },
        data: () => ({
            ckValue: '',
            communityCommonConstant,
            routerNames,
        }),
        mounted() {
            this.$nextTick(() => {
                trackPageLoadTime('ChapterPage');
            });
        },
        created() {
            if (this.$route.params.communityId) {
            gaDataLayerEvent(gtmEventName.C_Community_Page_Viewed, `${this.$route.name} | ${this.$route.params.communityId}`);
          }
        },
        computed: {
            ...mapGetters({
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
                isMainActivityFeedHidden: `chapter/${[storeGetters.isMainActivityFeedHidden]}`,
            }),
            isVisible() {
                return this.$route.params.communityId === undefined && this.$route.name !== this.routerNames.HOME;
            },
            showComponents() {
                return this.communityInfo && this.communityInfo.communityId === this.$route.params.communityId;
            },
            showBackToActivityFeedButton() {
                return this.$route.query && this.$route.query.postId;
            },
            chapterRoute() {
                return this.$route.name === this.routerNames.CHAPTER;
            },
            networkRoute() {
                return this.$route.name === this.routerNames.NETWORK;
            },
            showInappropriate() {
                return this.communityInfo
                    && this.communityInfo.communityId === this.$route.params.communityId
                    && this.communityInfo.userAccess
                    && this.communityInfo.userAccess.canViewInappropriateContent;
            },
            showFeatureEvents() {
                return this.communityInfo
                    && this.communityInfo.communityId === this.$route.params.communityId
                    && this.communityInfo.userAccess
                    && this.communityInfo.userAccess.canViewFeaturedEvents;
            },
            canViewActivityFeed() {
                return (this.$route.name && this.$route.name.toLowerCase() === routerNames.HOME.toLowerCase())
                    || (
                        this.communityInfo
                        && this.communityInfo.communityId === this.$route.params.communityId
                        && this.communityInfo.userAccess
                        && this.communityInfo.userAccess.canViewAllActivityFeed
                    );
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';

    //
    //
    //TODO: There are all temporary CSS
    //
    //
    //

    .chapter {
        &__left {
            min-height: 150px;
            background-color: $white;
            border: 1px solid $ypo-medium-gray;
            border-radius: 4px;
            text-align: center;
            font-weight: bold;
            margin-bottom: 15px;
            padding: 15px;
        }

        &__middle {
            min-height: 400px;
        }

        &__right {
            min-height: 150px;
            background-color: $white;
            border: 1px solid $ypo-medium-gray;
            border-radius: 4px;
            text-align: center;
            font-weight: bold;
            margin-bottom: 15px;
            padding: 15px;
        }
    }

    .sponsor {
        font-size: 22px !important;
        font-weight: 400;
        color: $ypo-blue;
    }

    .line-spacing {
        margin-right: 15px;
        margin-left: 15px;
    }

    h3 {
        color: $ypo-blue;
        font-size: 22px;
        letter-spacing: -0.72px;
        line-height: 30px;
        font-weight: 400;
        text-align: left;
    }

    .forum-reminder-pop {
        position: relative;
        background: $white;
        border-radius: 4px;
        width: 600px;

        &__details {
            position: relative;
            background: $white;
            z-index: 11;
            border-radius: 4px;

            .head {
                text-align: center;
                color: $black;
                font-family: Raleway;
                font-size: 14px;
                font-weight: bold;
                line-height: 34px;
                margin-top: 20px;

                span {
                    text-transform: uppercase;
                    position: relative;
                    padding: 3px 25px;

                    &:nth-child(2n) {
                        border-right: 1px solid $ypo-text-border;
                        border-left: 1px solid $ypo-text-border;
                    }
                }
            }
        }

        &:after {
            content: "";
            background: rgba($black, 0.75);
            position: fixed;
            width: 100%;
            height: 100%;
            z-index: 10;
            left: 0;
            top: 0;
        }

        h2 {
            color: $white;
            font-size: 18px;
            font-weight: bold;
            line-height: 22px;
            text-transform: uppercase;
            text-align: center;
            border-radius: 4px 4px 0 0;
            background-color: $ypo_blue;
            padding: 20px 0;
        }

        .desc {
            padding: 20px 30px;
            padding-bottom: 0px;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);

            strong {
                color: $ypo_blue;
                margin-bottom: 0px;
                display: block;
            }

            p {
                margin-bottom: 20px;
            }
        }
    }
</style>
